__turbopack_context__.v({
  "appShellMain": "layout-module__E4Uolq__appShellMain",
  "appShellMainContainer": "layout-module__E4Uolq__appShellMainContainer",
});
